/* #SACOOR# menu em gaveta estilo Scalpers */
(() => {
  if (customElements.get('sacoor-menu')) return;

  const desktopMq = window.matchMedia('(min-width: 768px)');
  const hoverMq = window.matchMedia('(hover: hover)');

  class SacoorMenu extends HTMLElement {
    connectedCallback() {
      // Passa para o <body> para o position: fixed não depender do header (sticky/transparente).
      // No editor, ao recarregar a secção, tira a cópia anterior que ficou no body.
      if (this.parentElement !== document.body) {
        document.querySelectorAll('body > sacoor-menu').forEach((old) => old.remove());
        document.body.appendChild(this);
        return;
      }
      if (this.ready) return;
      this.ready = true;
      this.opener = null;
      this.onKeydown = this.onKeydown.bind(this);
      this.onDocClick = this.onDocClick.bind(this);

      document.addEventListener('click', this.onDocClick);

      this.querySelectorAll('[data-sm-close]').forEach((el) => {
        el.addEventListener('click', (evt) => {
          evt.preventDefault();
          this.close();
        });
      });

      this.querySelectorAll('[data-sm-tab]').forEach((tab) => {
        tab.addEventListener('click', () => this.showTab(tab.dataset.smTab));
      });

      this.querySelectorAll('[data-sm-cat]').forEach((link) => {
        link.addEventListener('mouseenter', () => {
          if (desktopMq.matches && hoverMq.matches) this.showSub(link);
        });
        link.addEventListener('click', (evt) => {
          // Telemóvel: abre sempre o ecrã de subcategorias (o "Ver tudo" leva à categoria).
          // Desktop com toque: o 1.º toque abre as subcategorias, o 2.º segue o link.
          if (!desktopMq.matches || !link.classList.contains('is-active')) {
            evt.preventDefault();
            this.showSub(link);
          }
        });
      });

      this.querySelectorAll('[data-sm-back]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const pane = btn.closest('[data-sm-pane]');
          pane.classList.remove('is-sub-open');
          const active = pane.querySelector('[data-sm-cat].is-active');
          if (active) active.focus({ preventScroll: true });
        });
      });

      // Editor de temas: ao seleccionar um bloco de imagem do menu, abrir a gaveta no separador dele
      if (window.Shopify && Shopify.designMode) {
        this.onBlockSelect = (evt) => {
          const el = this.querySelector(`[data-shopify-editor-block*="${evt.detail.blockId}"]`);
          if (!el) return;
          this.open();
          this.showTab(el.closest('[data-sm-pane]').dataset.smPane);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }
    }

    disconnectedCallback() {
      if (!this.ready) return;
      this.ready = false;
      document.removeEventListener('click', this.onDocClick);
      document.removeEventListener('keydown', this.onKeydown);
      if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.documentElement.classList.remove('sm-lock');
    }

    onDocClick(evt) {
      const toggle = evt.target.closest('[data-sacoor-menu-toggle]');
      if (!toggle) return;
      evt.preventDefault();
      // HOMEM / MULHER no header: abre a gaveta já no separador deles
      const tab = toggle.dataset.sacoorMenuTab;
      if (this.classList.contains('is-open') && !tab) {
        this.close();
      } else {
        this.opener = toggle;
        if (tab) this.showTab(tab);
        this.open();
      }
    }

    open() {
      if (this.classList.contains('is-open')) return;
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('sm-lock');
      document.querySelectorAll('[data-sacoor-menu-toggle]').forEach((t) => t.setAttribute('aria-expanded', 'true'));
      document.addEventListener('keydown', this.onKeydown);
      const pane = this.querySelector('[data-sm-pane].is-active');
      if (pane) this.showDefaultSub(pane);
      setTimeout(() => this.querySelector('.sm__close').focus(), 50);
    }

    close() {
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('sm-lock');
      document.querySelectorAll('[data-sacoor-menu-toggle]').forEach((t) => t.setAttribute('aria-expanded', 'false'));
      document.removeEventListener('keydown', this.onKeydown);
      this.querySelectorAll('.is-sub-open').forEach((p) => p.classList.remove('is-sub-open'));
      if (this.opener) this.opener.focus();
    }

    showTab(index) {
      this.querySelectorAll('[data-sm-tab]').forEach((tab) => {
        const on = tab.dataset.smTab === String(index);
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this.querySelectorAll('[data-sm-pane]').forEach((pane) => {
        const on = pane.dataset.smPane === String(index);
        pane.classList.toggle('is-active', on);
        pane.classList.remove('is-sub-open');
        pane.hidden = !on;
        if (on) this.showDefaultSub(pane);
      });
      this.querySelector('.sm__body').scrollTop = 0;
    }

    // No desktop a coluna da direita nunca fica vazia: mostra a 1.ª categoria com filhos
    showDefaultSub(pane) {
      if (!desktopMq.matches || pane.querySelector('[data-sm-cat].is-active')) return;
      const first = pane.querySelector('[data-sm-cat]');
      if (first) this.showSub(first);
    }

    showSub(link) {
      const pane = link.closest('[data-sm-pane]');
      const id = link.dataset.smCat;
      pane.querySelectorAll('[data-sm-cat]').forEach((l) => {
        const on = l === link;
        l.classList.toggle('is-active', on);
        l.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      pane.querySelectorAll('[data-sm-sub]').forEach((sub) => {
        sub.hidden = sub.dataset.smSub !== id;
      });
      if (!desktopMq.matches) {
        pane.classList.add('is-sub-open');
        const back = pane.querySelector(`[data-sm-sub="${id}"] [data-sm-back]`);
        // preventScroll: o botão ainda está fora do ecrã (a entrar pela direita); sem isto o browser
        // fazia scroll para o mostrar e o ecrã de subcategorias saltava em vez de deslizar
        if (back) back.focus({ preventScroll: true });
      }
    }

    onKeydown(evt) {
      if (evt.key === 'Escape') {
        this.close();
        return;
      }
      if (evt.key !== 'Tab') return;
      const focusables = [...this.querySelectorAll('a[href], button')].filter((el) => el.offsetParent !== null);
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (evt.shiftKey && document.activeElement === first) {
        evt.preventDefault();
        last.focus();
      } else if (!evt.shiftKey && document.activeElement === last) {
        evt.preventDefault();
        first.focus();
      }
    }
  }

  customElements.define('sacoor-menu', SacoorMenu);
})();
/* #SACOOR# */
